const EmptyState: any = ({ selectedCompany, onEdit }: any) => {
  return (
    <div className="empty-dashboard card">
      <i className="ti ti-layout-dashboard" />
      <h5>No dashboard components</h5>
      <p>
        {!selectedCompany
          ? "Select a company to view dashboard data"
          : "Click 'Add Components' or 'Edit Dashboard' to start customizing your dashboard"}
      </p>
      {selectedCompany && (
        <div className="mt-3 p-3 d-flex justify-content-center">
          <button
            className="btn btn-info btn-md d-flex align-items-center"
            onClick={onEdit}>
            <i className="ti ti-plus me-2 fs-16 mt-0 mb-0" />
            Add Components
          </button>
        </div>
      )}
    </div>
  );
};

export default EmptyState;
